import React, { useMemo } from "react";
import { Card } from "semantic-ui-react";
import { MarketplaceAppCardProps } from "../types";
import MarketplaceCardHeader from "./MarketplaceCardHeader";

const MarketplaceAppCard: React.FC<MarketplaceAppCardProps> = ({ app }) => {
  const parsedDescription = useMemo(() => {
    if (typeof app.description === "string") {
      try {
        return JSON.parse(app.description);
      } catch (e) {
        console.error("Error parsing app.description:", e);
        return {};
      }
    } else if (typeof app.description === "object") {
      return app.description;
    } else {
      return {};
    }
  }, [app.description]);

  return (
    <Card className="marketplace-card width-100p">
      <Card.Content>
        <MarketplaceCardHeader app={app} />
        <Card.Description className="description">
          {parsedDescription.preview_description}
        </Card.Description>
      </Card.Content>
    </Card>
  );
};

export default MarketplaceAppCard;
